import { Button } from "primereact/button";
import { useState } from "react";

const AddTaskQBtn = ({ handleAddQuesTask, isLocked = false }) => {
  const [isTaskQBtnClicked, setIsTaskQBtnClicked] = useState(false);

  return (
    <div className="d-flex align-items-center justify-content-end mt-3">
      {!isTaskQBtnClicked ? (
        <Button
          className="createClientBtn py-1 fw-bold px-1 fs-12"
          onClick={() => setIsTaskQBtnClicked(true)}
          disabled={isLocked}
        >
          + Add Task/Question
        </Button>
      ) : (
        <div className="d-flex align-items-center justify-content-end">
          <div className="addTaskQuesBtn d-flex align-items-center fw-bold fs-12 py-1 fw-bold px-2">
            <Button
              className="linkBtn p-0 fw-bold fs-12"
              link
              onClick={() => handleAddQuesTask("task")}
              disabled={isLocked}
            >
              + Add Task
            </Button>
            <span className="mx-2">|</span>
            <Button
              className="linkBtn p-0 fw-bold fs-12"
              link
              onClick={() => handleAddQuesTask("question")}
              disabled={isLocked}
            >
              + Add Question
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddTaskQBtn;
